import { validateText } from "../../../../../common/utils";

export function getIsValid(application) {
  let newIsValid = {};

  ["mentor", "mentee"].forEach((key) => {
    let isValid = false;

    if (!application.accepts[key]) {
      isValid = true;
    } else if (
      application[key].every((question) => {
        const isTextValid = validateText(question.question);

        const isMultipleOptionsValid =
          !question.multipleQuestion ||
          (Array.isArray(question.multipleQuestion.options) &&
            question.multipleQuestion.options.length > 0 &&
            question.multipleQuestion.options.every(
              (option) => typeof option === "string" && option.trim() !== ""
            ));
        return isTextValid && isMultipleOptionsValid;
      })
    ) {
      isValid = true;
    }

    newIsValid[key] = isValid;
  });

  return newIsValid;
}
